/* Somewear — search overlay with Shopify Predictive Search. */
(() => {
  const S = window.Somewear;

  class SearchOverlay extends S.Overlay {
    connectedCallback() {
      super.connectedCallback();
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.initialHTML = this.results.innerHTML;
      this.cache = new Map();
      this.controller = null;

      this.input.addEventListener('input', S.debounce(() => this.onInput(), 180));
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          const first = this.results.querySelector('a');
          if (first) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      this.results.addEventListener('keydown', (event) => this.onResultsKeydown(event));
    }

    initialFocus() {
      return this.input;
    }

    onOpen() {
      window.setTimeout(() => this.input.select(), 60);
    }

    onResultsKeydown(event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const links = [...this.results.querySelectorAll('a')];
      const index = links.indexOf(document.activeElement);
      if (index === -1) return;
      event.preventDefault();
      if (event.key === 'ArrowUp' && index === 0) {
        this.input.focus();
        return;
      }
      const next = links[index + (event.key === 'ArrowDown' ? 1 : -1)];
      if (next) next.focus();
    }

    async onInput() {
      const term = this.input.value.trim();
      if (!term) {
        this.results.innerHTML = this.initialHTML;
        this.classList.remove('has-results');
        return;
      }
      if (this.cache.has(term)) {
        this.show(this.cache.get(term));
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.classList.add('is-loading');

      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
      });

      try {
        const response = await fetch(`${S.routes.predictive_search_url}?${params}`, {
          signal: this.controller.signal,
        });
        if (!response.ok) throw new Error(response.status);
        const doc = S.parseHTML(await response.text());
        const markup = doc.querySelector('[data-predictive-results]');
        const html = markup ? markup.outerHTML : `<p class="predictive__empty h3">${S.strings.noResults}</p>`;
        this.cache.set(term, html);
        // Ignore stale responses if the visitor kept typing.
        if (this.input.value.trim() === term) this.show(html);
      } catch (error) {
        if (error.name !== 'AbortError') this.results.innerHTML = this.initialHTML;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    show(html) {
      this.results.innerHTML = html;
      this.classList.add('has-results');
    }
  }
  customElements.define('search-overlay', SearchOverlay);
})();
